<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.search(v-if='!loading')
        .grid
          .col-4_xs-12.titles
            h2.h-l
              | search
          .col-8_xs-12.results(v-if="results")
            .grid
              .col-8_xs-12(v-for="item in loadedData")
                router-link(:to="path(item)")
                  h2.h-m
                    | {{ item.title }}
                  p.h-sxx(v-html="text(item)")
          .col-8_xs-12.results(v-else)
            h3.sorry.h-m
              | Sorry!
            p
              | We couldn't find any results.
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'search',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: {},
      // url: 'http://localhost:8888/caam_live/api/search?query='
      url: 'https://caamuseum.org/api/search?query='
    }
  },

  created () {
    this.search()
  },

  computed: {
    query () {
      return this.$route.query.query
    },

    results () {
      return this.loadedData.length > 0
    },

    key () {
      return 'search'
    }
  },

  methods: {
    search () {
      const url = this.url + this.query
      this.loading = true
      this.get(url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    path (item) {
      if (item.parent === 'programs') {
        const prefix = item.content.category.split(' ').join('-').toLowerCase()
        const path = 'programs/' + prefix + '/' + item.uid
        return {path: path}
      } else {
        return {path: item.uri}
      }
    },

    text (item) {
      return item.content.text
    }
  },

  watch: {
    $route () {
      this.search()
    }
  }
}
</script>

<style lang="sass">
  .content
    &.search
      .results
        margin-top: 14rem
        h2
          padding-top: 0.4rem
          display: inline
          border-bottom: solid 2px #FFF
      h2, h3, h4, a
        padding: 0
        margin: 0
      a
        &:hover h3
          border-bottom: solid 2px #000
</style>



// WEBPACK FOOTER //
// Search.vue?57323768